import React, { useState } from 'react'
import { FiTrendingUp } from 'react-icons/fi'
import { HiOutlineDocumentDownload, HiUsers } from 'react-icons/hi'
import CustomDropdown from '../../Components/CustomDropdown'
import styles from "./Styles/Finance.module.css"
import Search from "../../Components/Search"
import { useNavigate } from 'react-router-dom'

export default function Finance() {

  const [selectedTab, setSelectedTab] = useState('Earnings')
  const navigate = useNavigate()

  return (
    <div className={styles.container}>
        <header>
        <p>Financial Summary</p>

        <div className={styles.dropdownContainer}>
        <CustomDropdown value="Last 30 Days" options={['one','two']} />
        </div>
      </header>

      <div className={styles.headerCards}>
        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#DAEEFF'}} className={styles.cardIcon}>
            <HiUsers color="#299EFE" size={20} />
            </div>
            <h2>Invoices Generated</h2>
          </div>
            <h1>20</h1>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>Amount Due</h2>
          </div>
          <h1>₹90000</h1>
        </div>

        <div className={styles.card}>
          <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:10}}>
            <div style={{backgroundColor:'#F5E8DC'}} className={styles.cardIcon}>
            <HiUsers color="#D17E4F" size={20} />
            </div>
            <h2>Earnings</h2>
          </div>

          <div>
            <h1>₹1.67 L</h1>
          </div>
        </div>
      </div>


      <div className={styles.tabs}>
        <div onClick={()=>setSelectedTab('Earnings')} className={selectedTab == 'Earnings' && styles.activeTab}>Earnings</div>
        <div onClick={()=>setSelectedTab('Transaction')} className={selectedTab == 'Transaction' && styles.activeTab}>Transaction</div>
      </div>

      <div className={styles.search}>
      <Search placeholder="Search here..." />
      <CustomDropdown options={["asd"]} white value="Last 30 days" />
      </div>


      {selectedTab == 'Earnings' && <table cellPadding={0} cellSpacing={0} className={styles.table}>
      <thead>
              <tr>
                <th>Lead</th>
                <th>Date</th>
                <th>Project</th>
                <th>Description</th>
                <th>Overall Rate</th>
                <th>Paid</th>
                <th>Earning Rate</th>
                <th>Status</th>
                <th>Earned</th>
              </tr>
            </thead>
            <tbody>
              {Array(6).fill('').map(i => {
                return <tr onClick={()=>navigate('details')}>
                <td className={styles.leadId}>45216</td>
                <td>Nov 23, 2022</td>
                <td>Kalra Furniture</td>
                <td>Milestone 1 Completed</td>
                <td>10%</td>
                <td>₹15,000.00</td>
                <td>2%</td>
                <td>Pending</td>
                <td>₹15,000.00</td>
              </tr>
              })}
            </tbody>
      </table>}

      {selectedTab == 'Transaction' && <table cellPadding={0} cellSpacing={0} className={styles.table}>
            <thead>
              <tr>
                <th>Invoice</th>
                <th>Generated On</th>
                <th>Amount</th>
                <th>Paid On</th>
                <th>Paid Via</th>
                <th>Description</th>
                <th>Earned</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Array(3).fill('').map(i => {
                return <tr onClick={()=>navigate('details')}>
                <td className={styles.leadId}>45216</td>
                <td>Nov 23, 2022</td>
                <td>₹15,000.00</td>
                <td>Nov 23, 2022</td>
                <td>RTGS</td>
                <td>Milestone 1 Completed</td>
                <td>₹15,000.00</td>
                <td>
                  <button className={styles.downloadIcon}>
                    <HiOutlineDocumentDownload color="#299EFE" size={22} />
                  </button>
                </td>
              </tr>
              })}
            </tbody>
      </table>}
    </div>
  )
}
